import {api, RequestParam} from "@/shared/api";
import {ButtonRadioGroup} from "@/shared/ui/buttonRadioGroup";
import {Integrations} from "../integrations";
import {ExportWorkingTimeTypesMode, PersonioConfig} from "./personio";
import {FormUtil} from "@/shared/forms/formUtil";
import {htmlEscape} from "@/shared/utils/string";
import * as BootstrapModal from "@/shared/ui/bootstrapModal";
import * as Button from "@/shared/utils/button";
import * as Input from "@/shared/utils/input";
import {copyOfObject} from "@/shared/utils/misc";
import {FieldError, Integration, WorkingTimeType} from "@/shared/timr";
import {DurationUnit, IntegrationType, WorkingTimeTypeCategory} from "@/shared/timrTypes";

const template = `
	<div id="personioConfigDialog">
		<form id="personioConfigForm" class="form-horizontal">
			<div class="form-group">
				<div class="col-xs-12">
					<div class="text-bold">${messages["integrations.personio.oauth"]}</div>
					<div class="flex-row justify-left pt-8 mb-10 form-group">
						<div class="col-xs-2 flex-vertical-center">
							<label class="text-nowrap mr-20" for="personioClientId">${messages["integrations.personio.oauth.clientId"]}</label>
						</div>
						<div class="col-xs-10">
							<input type="text" class="form-control width-350" id="personioClientId" name="clientId" placeholder="${messages["integrations.personio.oauth.clientId"]}"/>
						</div>
					</div>
					<div class="flex-row justify-left pt-8 form-group">
						<div class="col-xs-2 flex-vertical-center">
							<label class="text-nowrap mr-20" for="personioClientSecret">${messages["integrations.personio.oauth.clientSecret"]}</label>
						</div>
						<div class="col-xs-10">
							<input type="password" class="form-control width-350" id="personioClientSecret" name="clientSecret" placeholder="${messages["integrations.personio.oauth.clientSecret"]}"/>
						</div>
					</div>
					<div class="flex-row justify-left pt-8 form-group">
						<div class="col-xs-push-2 col-xs-10">
							<a href="#" class="btn btn-default pull-right" id="personioCheckConfiguration">${messages["integrations.personio.checkCredentials"]}</a>
						</div>
					</div>
					<div class="mb-20">
						<div class="text-bold">${messages["integrations.personio.workingTimes"]}</div>
						<label class="checkbox-inline" for="personioTransferWorkingTimes">${messages["integrations.personio.syncWorkingTimes"]}
							<input type="checkbox" id="personioTransferWorkingTimes" name="syncWorkingTimes" />
						</label>
						
						<div id="personioExportWorkingTimeTypesContainer" class="panel panel-default mt-10">
							<p class="panel-title p-10 pb-0 text-bold">${messages["integrations.personio.exportWorkingTimeTypes.title"]}</p>
							<div class="panel-body p-10">
								<div class="btn-group display-flex justify-content-center">
									<button id="personioAllWorkingTimeTypesButton" type="button" class="btn btn-default" value="ALL_WORKING_TIME_TYPES">
										${messages["integrations.personio.exportWorkingTimeTypes.ALL_WORKING_TIME_TYPES"]}
									</button>
									<button id="personioAllAttendanceTimeTypesButton" type="button" class="btn btn-default" value="ALL_ATTENDANCE_TIME_TYPES">
										${messages["integrations.personio.exportWorkingTimeTypes.ALL_ATTENDANCE_TIME_TYPES"]}
									</button>
									<button id="personioSelectedWorkingTimeTypesButton" type="button" class="btn btn-default" value="SELECTED_WORKING_TIME_TYPES">
										${messages["integrations.personio.exportWorkingTimeTypes.SELECTED_WORKING_TIME_TYPES"]}
									</button>
								</div>
								<div id="personioAllWorkingTimeTypesInfo" class="input-info-text p-20 pb-0">
									<i class="fal fa-info-circle"></i> ${messages["integrations.personio.exportWorkingTimeTypes.ALL_WORKING_TIME_TYPES.info"]}
								</div>
								<div id="personioAllAttendanceTimeTypesInfo" class="input-info-text p-20 pb-0">
									<i class="fal fa-info-circle"></i> ${messages["integrations.personio.exportWorkingTimeTypes.ALL_ATTENDANCE_TIME_TYPES.info"]}
								</div>
								<div id="personioWorkingTimeTypesContainer" class="mt-15">
									<!-- Add working time types here -->
								</div>
								<div id="personioAllNewAutoSelectInfo" class="input-info-text p-20 pb-0">
									<i class="fal fa-info-circle"></i> ${messages["integrations.personio.exportWorkingTimeTypes.newWorkingTimeTypes.info"]}
								</div>
							</div>
						</div>
						
						<div class="ml-50 mr-20 flex-column">
							<div class="flex-row justify-content-space-between">
								<label class="checkbox-inline" for="personioSkipApproval">${messages["integrations.personio.skipApproval"]}
									<input data-personio-working-time type="checkbox" id="personioSkipApproval" name="skipApproval" />
								</label>
								<label class="checkbox-inline" for="personioSplitAtMidnight">${messages["integrations.personio.splitAtMidnight"]}
									<input data-personio-working-time type="checkbox" id="personioSplitAtMidnight" name="splitRecordingsAtMidnight" />
								</label>
							</div>
							<div class="flex-row flex-vertical-center mb-10 mt-15 form-group-custom-field">
								<label class="text-nowrap mb-0 mr-10" for="personioSyncWorkingTimesDaysBack">${messages["integrations.personio.maxDaysBack.1"]}</label>
								<input data-personio-working-time type="number" class="form-control" id="personioSyncWorkingTimesDaysBack" name="syncWorkingTimesDaysBack" placeholder="90" style="max-width: 75px"/>
								<label class="text-nowrap mb-0 ml-10" for="personioSyncWorkingTimesDaysBack">${messages["integrations.personio.maxDaysBack.2"]}</label>
							</div>
							<label class="checkbox-inline mb-10" for="personioTransferNotes">${messages["integrations.personio.transferNotes"]}
								<input data-personio-working-time type="checkbox" id="personioTransferNotes" name="copyDescription" />
							</label>
							<label class="checkbox-inline mb-10 ml-0" for="personioWorkingTimeTypeAsNote">${messages["integrations.personio.transfer.workingTimeType.name"]}
								<input data-personio-working-time type="checkbox" id="personioWorkingTimeTypeAsNote" name="copyTypeName" />
							</label>
							<label class="checkbox-inline m-0" for="personioWorkingTimeTypeShortAsNote">${messages["integrations.personio.transfer.workingTimeType.shortname"]}
								<input data-personio-working-time type="checkbox" id="personioWorkingTimeTypeShortAsNote" name="copyTypeShortname" />
							</label>
							<a href="#" class="btn btn-default mt-20 mr-50" id="personioResetWTConfig">${messages["integrations.personio.defaultConfig"]}</a>
						</div>
					</div>
					${ /* DEVNOTE: Hide Dummy bookings temporarily (TIMR-7969) dummyBookings can be inlined again if needed */ ""}
				</div>
			</div>
		</form>
	</div>
	`;

export class PersonioConfigDialog extends HTMLElement {
	private static readonly EXTERNAL_ID_PREFIX_ATTENDANCE = "PERSONIO_ATTENDANCE";
	private static readonly EXTERNAL_ID_PREFIX_BREAKTIME = "PERSONIO_BREAKTIME";

	private dom: JQuery;
	private modal: BootstrapModal.Modal;

	private config: PersonioConfig;

	private workingTimesCheckbox: JQuery;
	private dummyBookingsCheckbox: JQuery;

	private exportWorkingTimeTypesControl: ButtonRadioGroup<ExportWorkingTimeTypesMode>;
	private loadWorkingTimeTypeRequest: JQueryXHR;

	private locallySelectedWorkingTimeTypes: string[];

	private editMode: boolean;
	private editIntegration: Integration;

	public static create() {
		const dialog = document.createElement("personio-config-dialog") as PersonioConfigDialog;
		$("body").append(dialog);
		dialog.create();
		dialog.remove();
	}

	public static edit(integration: Integration, configuration: PersonioConfig) {
		const dialog = document.createElement("personio-config-dialog") as PersonioConfigDialog;
		$("body").append(dialog);
		dialog.edit(integration, configuration);
		dialog.remove();
	}

	private connectedCallback() {
		this.innerHTML = template;

		this.dom = $("#personioConfigDialog");
		this.modal = new BootstrapModal.Modal({
			title: `<img src="/timr/images/integrations/personio.svg" width="100px">`,
			escapeText: false,
			message: this.dom,
			destroyOnClose: true,
			buttons: [
				{
					text: "dialog.save",
					css: "saveButton btn-primary",
					action: () => {
						if (!this.editMode) {
							Integrations.triggerAddedIntegrationEvent(IntegrationType.PERSONIO, this.convertFormToJSONString($("#personioConfigForm")));
						} else {
							Integrations.triggerEditedIntegrationEvent(IntegrationType.PERSONIO, this.editIntegration, this.convertFormToJSONString($("#personioConfigForm")));
						}
					}
				},
				{
					text: "dialog.cancel",
					css: "cancelButton btn-default"
				},
				{
					text: "dialog.delete",
					css: "deleteButton btn-danger",
					left: true,
					action: (m) => {
						BootstrapModal.confirm({
							title: messages["dialog.delete.confirm"],
							message: messages["integrations.personio.delete.message"],
							yesAction: (confirmModal) => {
								confirmModal.close();
								m.close();
								Integrations.triggerDeletedIntegrationEvent(IntegrationType.PERSONIO, this.editIntegration.id);
							}
						});
					}
				}
			],
			onOpen: (m) => {
				Input.toggle(m.find(".deleteButton"), this.editMode);
				this.updateCheckboxes();
				this.dom.find("#personioClientId").focus();
				Integrations.onSaveIntegration(IntegrationType.PERSONIO, (e, fieldErrors: FieldError[]) => {
					if (!fieldErrors) {
						m.close();
					} else {
						FormUtil.markFieldErrors($("#personioConfigForm"), fieldErrors);
						m.resetLoadingButtons();
					}
				});

				Integrations.onConfigurationChecked(IntegrationType.PERSONIO, (e, success: boolean) => {
					const checkBtn = m.find("#personioCheckConfiguration");
					Button.resetLoading(checkBtn, success ?
						`<div class="text-success-800"><i class="fa fa-check"></i> ${messages["integrations.personio.checkCredentials.success"]}</div>` :
						`<div class="text-danger-800"><i class="fa fa-times"></i> ${messages["integrations.personio.checkCredentials.failure"]}</div>`);

					if (!success) {
						setTimeout(() => {
							checkBtn.children("div").fadeOut(600, () => {
								checkBtn.html(messages["integrations.personio.checkCredentials"]).fadeIn(600);
							});
						}, 3000);
					}
				});
			}
		});

		this.init();
	}

	private init() {
		this.initListeners();
		this.initExportWorkingTimeTypesControl();
		this.initPopup();
	}

	private create() {
		this.editMode = false;
		this.resetModal();
		this.modal.show();
	}

	private edit(editIntegration: Integration, config: PersonioConfig) {
		this.editIntegration = editIntegration;
		this.config = copyOfObject(config);
		this.editMode = true;
		this.resetModal(config);
		this.modal.show();
	}

	private initListeners() {
		this.workingTimesCheckbox = this.dom.find("#personioTransferWorkingTimes");
		this.workingTimesCheckbox.on("change", () => {
			this.updateCheckboxes();
		});

		this.dummyBookingsCheckbox = this.dom.find("#personioDummyBookings");
		this.dummyBookingsCheckbox.on("change", () => {
			this.updateCheckboxes();
		});

		this.dom.find("#personioResetWTConfig").on("click", () => {
			this.resetModal(null, true);
			this.updateCheckboxes();
		});

		this.dom.find("#personioClientId,#persionioClientSecret").on("change", () => {
			this.dom.find("#personioCheckConfiguration").html(messages["integrations.personio.checkCredentials"]);
		});

		this.dom.find("#personioCheckConfiguration").on("click", (e) => {
			// Make sure to change the button and not some other layout element
			Button.setLoading($(e.target).closest("#personioCheckConfiguration"));
			Integrations.triggerCheckIntegrationConfigurationEvent(IntegrationType.PERSONIO, this.convertFormToJSONString($("#personioConfigForm")));
		});
	}

	private initPopup() {
		$("[data-open-info-popup]").popover({
			trigger: "hover",
			container: ".content-wrapper",
			delay: {show: 500, hide: 0},
			placement: "top",
			html: true,
			template: `<div class="popover width-150" role="tooltip">
								<div class="arrow"></div>
								<div class="popover-content"></div>
							</div>`,
			content: function () {
				const content = $(this).data("open-info-popup") as string;
				return `<div>${messages[content]}</div>`;
			}
		} as PopoverOptions);
	}

	private resetModal(config?: PersonioConfig, resetOnlyWorkingTimeConfig?: boolean) {
		if (!resetOnlyWorkingTimeConfig) {
			this.dom.find("#personioClientId").val(config?.clientId ?? "");
			this.dom.find("#personioClientSecret").val(config?.clientSecret ?? "");
			this.dom.find("#personioTransferWorkingTimes").prop("checked", config?.syncWorkingTimes ?? false);
			this.dom.find("#personioDummyBookings").prop("checked", config?.dummyAttendances ?? false);
			this.dom.find("#personioMaxDummyDaysBack").val(config?.dummyAttendancesDaysBack ?? 90);
			this.dom.find("#personioExportWorkingTimeTypesContainer").toggle(config?.syncWorkingTimes);
		}
		this.dom.find("#personioSkipApproval").prop("checked", config?.skipApproval ?? true);
		this.dom.find("#personioSplitAtMidnight").prop("checked", config?.splitRecordingsAtMidnight ?? true);
		this.dom.find("#personioSyncWorkingTimesDaysBack").val(config?.syncWorkingTimesDaysBack ?? 90);
		this.dom.find("#personioTransferNotes").prop("checked", config?.copyDescription ?? true);
		this.dom.find("#personioWorkingTimeTypeAsNote").prop("checked", config?.copyTypeName ?? true);
		this.dom.find("#personioWorkingTimeTypeShortAsNote").prop("checked", config?.copyTypeShortname ?? false);

		if (config?.workingTimeTypeMode) {
			this.exportWorkingTimeTypesControl.setValue(config.workingTimeTypeMode);
		} else {
			// If clientId is set, the integration is already configured and
			// might have working time types setup for personio already
			this.exportWorkingTimeTypesControl.setValue(config?.clientId ? ExportWorkingTimeTypesMode.SELECTED_WORKING_TIME_TYPES : ExportWorkingTimeTypesMode.ALL_WORKING_TIME_TYPES);
		}
		if (resetOnlyWorkingTimeConfig && this.config?.workingTimeTypeIds) {
			// Reset working time type checkboxes if available
			this.config.workingTimeTypeIds = [];
		}
	}

	private updateCheckboxes() {
		// working times
		const workingTimeConfig = this.dom.find("[data-personio-working-time]");
		const workingTimeChecked = this.workingTimesCheckbox.is(":checked");
		$("#personioExportWorkingTimeTypesContainer").slideToggleBool(workingTimeChecked);
		if (workingTimeChecked) {
			Input.enable(workingTimeConfig);
		} else {
			Input.disable(workingTimeConfig);
		}

		// dummy bookings
		const dummyBookingConfig = this.dom.find("[data-personio-dummy-bookings]");
		if (this.dummyBookingsCheckbox.is(":checked")) {
			Input.enable(dummyBookingConfig);
		} else {
			Input.disable(dummyBookingConfig);
		}

	}

	private initExportWorkingTimeTypesControl() {
		this.exportWorkingTimeTypesControl = ButtonRadioGroup.typed({
			value: ExportWorkingTimeTypesMode.ALL_WORKING_TIME_TYPES,
			button: document.getElementById("personioAllWorkingTimeTypesButton")
		}, {
			value: ExportWorkingTimeTypesMode.ALL_ATTENDANCE_TIME_TYPES,
			button: document.getElementById("personioAllAttendanceTimeTypesButton")
		}, {
			value: ExportWorkingTimeTypesMode.SELECTED_WORKING_TIME_TYPES,
			button: document.getElementById("personioSelectedWorkingTimeTypesButton")
		}).onValueChanged((mode: ExportWorkingTimeTypesMode) => this.updateExportWorkingTimeTypes(mode));
	}

	private updateExportWorkingTimeTypes(mode: ExportWorkingTimeTypesMode) {
		const allWorkingTimeTypes = this.dom.find("#personioAllWorkingTimeTypesInfo");
		const allAttendanceTimeTypes = this.dom.find("#personioAllAttendanceTimeTypesInfo");
		const allNewAutoSelectInfo = this.dom.find("#personioAllNewAutoSelectInfo");

		switch (mode) {
			case ExportWorkingTimeTypesMode.ALL_WORKING_TIME_TYPES:
				allWorkingTimeTypes.show();
				allNewAutoSelectInfo.show();
				allAttendanceTimeTypes.hide();
				break;
			case ExportWorkingTimeTypesMode.ALL_ATTENDANCE_TIME_TYPES:
				allWorkingTimeTypes.hide();
				allNewAutoSelectInfo.show();
				allAttendanceTimeTypes.show();
				break;
			case ExportWorkingTimeTypesMode.SELECTED_WORKING_TIME_TYPES:
				allWorkingTimeTypes.hide();
				allNewAutoSelectInfo.hide();
				allAttendanceTimeTypes.hide();
				break;
		}
		this.loadWorkingTimeTypes(mode);
	}

	private loadWorkingTimeTypes(mode: ExportWorkingTimeTypesMode) {
		const params: RequestParam[] = [];
		params.push({name: "archived", value: false});
		params.push({name: "editUnit", value: DurationUnit.Minutes});
		if (mode === ExportWorkingTimeTypesMode.ALL_ATTENDANCE_TIME_TYPES) {
			params.push({
				name: "categories",
				value: [WorkingTimeTypeCategory.AttendanceTime, WorkingTimeTypeCategory.BreakTime].toString()
			});
		} else {
			params.push({
				name: "categories",
				value: [WorkingTimeTypeCategory.AttendanceTime, WorkingTimeTypeCategory.BreakTime, WorkingTimeTypeCategory.PaidTimeOff].toString()
			})
		}

		this.loadWorkingTimeTypeRequest?.abort();
		this.loadWorkingTimeTypeRequest = api("admin/workingTimeTypes.json")
			.get(params)
			.done((response: { data: WorkingTimeType[] }) => {
				const container = this.dom.find("#personioWorkingTimeTypesContainer");
				container.empty();
				container.append(this.createWorkingTimeTypeHeader());
				const workingTimeTypesScrollContainer = $("<div>")
					.addClass("scroll-container restrict-height");
				response.data.forEach((type) => {
					const checkbox = this.createWorkingTimeTypeCheckbox(type, mode);
					workingTimeTypesScrollContainer.append(checkbox);
				});
				container.append(workingTimeTypesScrollContainer);
				this.locallySelectedWorkingTimeTypes = this.findAllSelectedWorkingTimeTypes(workingTimeTypesScrollContainer);
			});
	}

	private createWorkingTimeTypeHeader() {
		return $(`
				<div class="flex-row justify-content-space-between scroll-container">
					<p class="text-bold">${messages["integrations.personio.workingTimeType"]}</p>
					<p class="text-bold">${messages["integrations.personio.export"]}</p>
				</div>
			`);
	}

	private createWorkingTimeTypeCheckbox(wtt: WorkingTimeType, mode: ExportWorkingTimeTypesMode): JQuery {
		return $(`
				<div class="flex-row justify-content-space-between">
					<label for="personioWorkingTimeType-${wtt.id}">${htmlEscape(wtt.name)}</label>
					<input type="checkbox"
						id="personioWorkingTimeType-${wtt.id}"
						value="${wtt.workingTimeTypeId}"
						data-working-time-type
						${mode !== ExportWorkingTimeTypesMode.SELECTED_WORKING_TIME_TYPES ||
		(this.isTypeSelected(wtt) || (!this.config?.workingTimeTypeMode && this.hasPersonioExportExternalId(wtt.externalId))) ?
			"checked" : ""
		}
						${mode !== ExportWorkingTimeTypesMode.SELECTED_WORKING_TIME_TYPES ? "disabled" : ""}
					/>
				</div>
			`);
	}

	private isTypeSelected(wtt: WorkingTimeType): boolean {
		return this.config?.workingTimeTypeIds?.some((id: string) => id === wtt.workingTimeTypeId) ||
			this.locallySelectedWorkingTimeTypes?.some((id: string) => id === wtt.workingTimeTypeId);
	}

	private hasPersonioExportExternalId(externalId?: string): boolean {
		return externalId?.startsWith(PersonioConfigDialog.EXTERNAL_ID_PREFIX_ATTENDANCE) ||
			externalId?.startsWith(PersonioConfigDialog.EXTERNAL_ID_PREFIX_BREAKTIME);
	}

	private findAllSelectedWorkingTimeTypes(element: JQuery): string[] {
		return element.find("[data-working-time-type]:checked").toArray().map((elem: HTMLElement) => $(elem).val() as string);
	}

	private convertFormToJSONString(form: JQuery): string {
		/*
		 * SerializeArray() returns "on" for checked checkboxes w/o a value,
		 * so we set the value to true
		*/
		form.find("input[type=checkbox]:checked:not([data-working-time-type])").val("true");

		/* Get input values from form */
		const disabledInput = form.find("input:disabled");
		Input.enable(disabledInput);
		const array = form.serializeArray();
		Input.disable(disabledInput);

		// Built dynamically from form field names, so keyed by string; values are the serialized strings plus the two structured fields set below.
		const personioConfig: Record<string, string | string[] | ExportWorkingTimeTypesMode> = {};
		$.each(array, (i, e) => {
			personioConfig[e.name] = e.value || "";
		});

		/* Because serializeArray() ignores unset checkboxes and radio buttons: */
		form.find("input[type=checkbox]:not(:checked):not([data-working-time-type])")
			.toArray()
			.filter(e => e instanceof HTMLInputElement)
			.forEach((elem: HTMLInputElement) => {
				personioConfig[elem.name] = "false"
			});

		const workingTimeTypeMode = this.exportWorkingTimeTypesControl.getValue();
		personioConfig.workingTimeTypeMode = workingTimeTypeMode;
		if (workingTimeTypeMode === ExportWorkingTimeTypesMode.SELECTED_WORKING_TIME_TYPES) {
			// Only add working time types if the mode is set to SELECTED_WORKING_TIME_TYPES to save a bit of performance/storage space
			// if a client has many working time types
			personioConfig.workingTimeTypeIds = this.findAllSelectedWorkingTimeTypes(form);
		} else {
			personioConfig.workingTimeTypeIds = [];
		}

		return JSON.stringify(personioConfig);
	}
}
